import { gql } from "@apollo/client";

export const GET_ALL_SUBMISSIONS = gql`
  query MissionAdminAllSubmissions($filter: MissionAdminSubmissionFilter) {
    missionAdminAllSubmissions(filter: $filter) {
      id
      participationId
      participation {
        id
        user {
          id
          name
          phone
        }
        run {
          id
          startAt
          endAt
          campaign {
            id
            productName
            productImageUrl
            brand {
              name
            }
            steps {
              id
              stepOrder
              title
            }
            runs {
              id
              startAt
              endAt
            }
          }
        }
        submissions {
          id
          participationId
          missionStepId
          stepOrder
          isSubmitted
          isApproved
          status
          submittedAt
          proofType
          proofData
        }
      }
      missionStepId
      step {
        id
        title
        guide
        requirements
        notices
        proofType
        isRequired
      }
      stepOrder
      windowStartAt
      windowEndAt
      isSubmitted
      isApproved
      status
      submittedAt
      reviewedAt
      approvedAt
      rejectedAt
      reviewerAccountId
      proofType
      proofData
      note
      createdAt
      updatedAt
    }
  }
`;

export const GET_PENDING_SUBMISSIONS = gql`
  query MissionAdminPendingSubmissions($filter: MissionAdminSubmissionFilter) {
    missionAdminPendingSubmissions(filter: $filter) {
      id
      participationId
      participation {
        id
        user {
          id
          name
          phone
        }
        run {
          id
          startAt
          endAt
          campaign {
            id
            productName
            productImageUrl
            brand {
              name
            }
            steps {
              id
              stepOrder
              title
            }
            runs {
              id
              startAt
              endAt
            }
          }
        }
        submissions {
          id
          participationId
          missionStepId
          stepOrder
          isSubmitted
          isApproved
          status
          submittedAt
          proofType
          proofData
        }
      }
      missionStepId
      step {
        id
        title
        guide
        requirements
        notices
        proofType
        isRequired
      }
      stepOrder
      windowStartAt
      windowEndAt
      isSubmitted
      isApproved
      status
      submittedAt
      reviewedAt
      approvedAt
      rejectedAt
      reviewerAccountId
      proofType
      proofData
      note
      createdAt
      updatedAt
    }
  }
`;

export const GET_SUBMISSION_DETAIL = gql`
  query MissionAdminSubmission($submissionId: Int!) {
    missionAdminSubmission(submissionId: $submissionId) {
      id
      participationId
      participation {
        id
        user {
          id
          name
        }
        run {
          id
          startAt
          endAt
          campaign {
            id
            productName
            productImageUrl
            brand {
              name
            }
            steps {
              id
              title
              isRequired
            }
          }
        }
      }
      missionStepId
      step {
        id
        title
        guide
        requirements
        notices
        proofType
        isRequired
      }
      stepOrder
      windowStartAt
      windowEndAt
      isSubmitted
      isApproved
      status
      submittedAt
      reviewedAt
      approvedAt
      rejectedAt
      reviewerAccountId
      proofType
      proofData
      note
      createdAt
      updatedAt
    }
  }
`;

export const GET_PENDING_WITHDRAWALS = gql`
  query MissionAdminPendingWithdrawals($filter: MissionAdminWithdrawalFilter) {
    missionAdminPendingWithdrawals(filter: $filter) {
      id
      walletId
      wallet {
        id
        availableBalance
        heldBalance
      }
      userId
      user {
        id
        name
      }
      amountRequested
      feeAmount
      amountToPay
      status
      reviewerAccountId
      rejectReason
      externalTransferRef
      bankName
      accountNumberMasked
      accountNumber
      accountHolder
      requestedAt
      reviewedAt
      paidAt
    }
  }
`;

export const GET_WITHDRAWAL_DETAIL = gql`
  query MissionAdminWithdrawal($withdrawalRequestId: Int!) {
    missionAdminWithdrawal(withdrawalRequestId: $withdrawalRequestId) {
      id
      walletId
      wallet {
        id
        availableBalance
        heldBalance
      }
      userId
      user {
        id
        name
      }
      amountRequested
      feeAmount
      amountToPay
      status
      reviewerAccountId
      rejectReason
      externalTransferRef
      bankName
      accountNumberMasked
      accountNumber
      accountHolder
      requestedAt
      reviewedAt
      paidAt
    }
  }
`;

export const GET_REVIEW_STATS = gql`
  query MissionAdminReviewStats {
    missionAdminReviewStats {
      pendingSubmissionsCount
      pendingWithdrawalsCount
    }
  }
`;

export const APPROVE_SUBMISSION = gql`
  mutation MissionAdminApproveSubmission($submissionId: Int!, $note: String) {
    missionAdminApproveSubmission(submissionId: $submissionId, note: $note) {
      ok
      error
    }
  }
`;

export const REJECT_SUBMISSION = gql`
  mutation MissionAdminRejectSubmission($submissionId: Int!, $note: String!) {
    missionAdminRejectSubmission(submissionId: $submissionId, note: $note) {
      ok
      error
    }
  }
`;

export const APPROVE_WITHDRAWAL = gql`
  mutation MissionAdminApproveWithdrawal($withdrawalRequestId: Int!) {
    missionAdminApproveWithdrawal(withdrawalRequestId: $withdrawalRequestId) {
      ok
      error
    }
  }
`;

export const REJECT_WITHDRAWAL = gql`
  mutation MissionAdminRejectWithdrawal(
    $withdrawalRequestId: Int!
    $rejectReason: String!
  ) {
    missionAdminRejectWithdrawal(
      withdrawalRequestId: $withdrawalRequestId
      rejectReason: $rejectReason
    ) {
      ok
      error
    }
  }
`;

export const MARK_WITHDRAWAL_PAID = gql`
  mutation MissionAdminMarkWithdrawalPaid(
    $withdrawalRequestId: Int!
    $externalTransferRef: String!
  ) {
    missionAdminMarkWithdrawalPaid(
      withdrawalRequestId: $withdrawalRequestId
      externalTransferRef: $externalTransferRef
    ) {
      ok
      error
    }
  }
`;

export const GET_FAILED_PARTICIPATIONS_FOR_FORFEIT = gql`
  query MissionAdminFailedParticipationsForForfeit(
    $filter: MissionAdminForfeitFilter
  ) {
    missionAdminFailedParticipationsForForfeit(filter: $filter) {
      participationId
      expiredStepCount
      notApprovedStepCount
      participation {
        id
        userId
        status
        joinedAt
        depositAmount
        prizeAmount
        user {
          id
          name
          phone
        }
        run {
          id
          startAt
          endAt
          campaign {
            id
            productName
            productImageUrl
            brand {
              name
            }
            steps {
              id
              stepOrder
              title
            }
          }
        }
      }
    }
  }
`;

export const FORFEIT_DEPOSIT = gql`
  mutation MissionAdminForfeitDeposit(
    $participationId: Int!
    $reason: String!
  ) {
    missionAdminForfeitDeposit(
      participationId: $participationId
      reason: $reason
    ) {
      ok
      error
    }
  }
`;

export const GET_SUCCESSFUL_PARTICIPATIONS_FOR_PAYBACK = gql`
  query MissionAdminSuccessfulParticipationsForPayback(
    $filter: MissionAdminPaybackFilter
  ) {
    missionAdminSuccessfulParticipationsForPayback(filter: $filter) {
      participationId
      participation {
        id
        userId
        status
        joinedAt
        depositAmount
        prizeAmount
        user {
          id
          name
          phone
        }
        run {
          id
          startAt
          endAt
          campaign {
            id
            productName
            productImageUrl
            brand {
              name
            }
            steps {
              id
              stepOrder
              title
            }
          }
        }
      }
      approvedStepCount
      totalStepCount
    }
  }
`;

export const COMPLETE_PARTICIPATION_AND_PAYBACK = gql`
  mutation MissionAdminCompleteParticipationAndPayback($participationId: Int!) {
    missionAdminCompleteParticipationAndPayback(
      participationId: $participationId
    ) {
      ok
      error
    }
  }
`;

export const CANCEL_PARTICIPATION = gql`
  mutation MissionAdminCancelParticipation(
    $participationId: Int!
    $cancelReason: String!
  ) {
    missionAdminCancelParticipation(
      participationId: $participationId
      cancelReason: $cancelReason
    ) {
      ok
      error
    }
  }
`;
